import {initMegaMenu} from "./Menu/MegaMenu";
import {initSearch} from "./Menu/Search";

export const initHeader = () => {
  const header = document.querySelector(".main-header");
  const main = document.querySelector(".main");

  if (!header || !main) return;

  const keepHeaderSmall = !!header.dataset.small;

  if (!keepHeaderSmall) {
    new ResizeObserver((entries) => {
      if (entries[0].target === header) {
        document.body.style.setProperty("--menu-height", `${header.scrollHeight}px`);
        fixContactBarPosition(header);
      }
    }).observe(header);
  }

  const updateHeaderSize = () => {
    header.classList.toggle("small", window.scrollY > (header.classList.contains('small') ? 50 : 200));
  };

  initSearch(header);
  initMegaMenu(header);
  if (!keepHeaderSmall) updateHeaderSize();
  initCSSTransitions();

  if (!keepHeaderSmall) window.addEventListener("scroll", updateHeaderSize, { passive: true });
};

function initCSSTransitions() {
  document.querySelector(".main-header .header-inner")?.classList.add("duration-500");

  const elements = document.querySelectorAll(
    [
      ".main-header .header-inner .logo img",
      ".main-header .header-inner .logo span",
      ".main-header .header-inner .main-menu ul .menu-item > div > .link-node",
    ].join(",")
  );

  for (const element of elements) {
    element.classList.add("duration-300");
  }

  document.querySelector("#search")?.classList.add("duration-[1s]");
}

function fixContactBarPosition(header) {
  const contactBar = document.getElementById("contact-bar");
  if (!header || !contactBar) return;
  contactBar.style.removeProperty("display");
  contactBar.style.setProperty("top", `${header.clientHeight}px`);
}
